export const TESTMODAL = 'TestModal';
export const MODAL_TYPES = {
  JOINCOMMUNITY: 'JOINCOMMUNITY',
  SHARE: 'SHARE',
  DELETE: 'DELETE',
  REPORT: 'REPORT',
  REPORT_RESPONSE: 'REPORT_RESPONSE',
};
export const ADMIN = 'Admin';
